module.exports = __webpack_public_path__ + "static/media/salisbury-9.4da1a618.jpg";